import React, { useState } from "react";
import api from "../Service/api"; // your Axios instance

function OwnerAddProduct() {
  const [productName, setProductName] = useState("");
  const [stepName, setStepName] = useState("");
  const [steps, setSteps] = useState([]);

  const addStep = () => {
    if (stepName.trim() === "") return;
    setSteps([...steps, stepName.trim()]);
    setStepName("");
  };

  const saveProduct = async () => {
    if (!productName || steps.length === 0) {
      alert("Enter product name and at least 1 step");
      return;
    }
    try {
      await api.post("/production/add-product", steps, {
        params: { productName },
      });
      alert("Product added successfully!");
      setProductName("");
      setSteps([]);
    } catch (err) {
      console.error(err.response?.data || err.message);
    }
  };

  return (
    <div style={{
  minHeight: "100vh",
  background: "#f1f5f9",
  fontFamily: "Inter, Arial, sans-serif",
  display: "flex",
  justifyContent: "center",
  // alignItems: "center", // remove this to avoid vertical centering
  paddingTop: "40px", // reduced top space
  paddingBottom: "20px",
  paddingLeft: "20px",
  paddingRight: "20px"
}}>


      {/* Card */}
      <div style={{
        background: "#ffffff",
        borderRadius: "8px",
        maxWidth: "900px",
        width: "100%",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        border: "1px solid #e2e8f0"
      }}>

        {/* Header inside Card */}
        <div style={{ padding: "24px" }}>
          <h1 style={{
            fontSize: "28px",
            fontWeight: "600",
            color: "#0f172a",
            marginBottom: "6px",
            textAlign: "center"
          }}>
            Production Setup
          </h1>
          <p style={{
            color: "#64748b",
            fontSize: "14px",
            textAlign: "center",
            marginBottom: "20px"
          }}>
            Define products and their production workflow
          </p>
        </div>

        {/* Card Header */}
        <div style={{
          padding: "16px 24px",
          borderBottom: "1px solid #e2e8f0",
          fontSize: "18px",
          fontWeight: "600",
          color: "#1e293b"
        }}>
          Add New Product
        </div>

        {/* Card Body */}
        <div style={{ padding: "24px" }}>
          {/* Product Name */}
          <div style={{ marginBottom: "20px", maxWidth: "400px" }}>
            <label style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "600",
              marginBottom: "6px",
              color: "#334155"
            }}>
              Product Name
            </label>
            <input
              type="text"
              placeholder="Add product"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #cbd5f5",
                fontSize: "14px"
              }}
            />
          </div>

          {/* Steps */}
          <div>
            <label style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#334155"
            }}>
              Production Steps
            </label>

            <div style={{ display: "flex", gap: "8px", maxWidth: "600px" }}>
              <input
                type="text"
                placeholder="Add Steps"
                value={stepName}
                onChange={(e) => setStepName(e.target.value)}
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5f5",
                  fontSize: "14px"
                }}
              />
              <button
                onClick={addStep}
                style={{
                  padding: "10px 18px",
                  background: "#2563eb",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "500"
                }}
              >
                Add
              </button>
            </div>

            {/* Steps List */}
            <div style={{ marginTop: "16px", maxWidth: "600px" }}>
              {steps.length === 0 ? (
                <div style={{
                  padding: "10px",
                  fontSize: "13px",
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: "6px",
                  color: "#64748b"
                }}>
                  No production steps added yet
                </div>
              ) : (
                <div style={{
                  border: "1px solid #e2e8f0",
                  borderRadius: "6px"
                }}>
                  {steps.map((s, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px 12px",
                        borderBottom: i !== steps.length - 1
                          ? "1px solid #e2e8f0"
                          : "none",
                        fontSize: "14px"
                      }}
                    >
                      <span>{i + 1}. {s}</span>
                      <button
                        onClick={() =>
                          setSteps(steps.filter((_, idx) => idx !== i))
                        }
                        style={{
                          color: "#dc2626",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          fontSize: "13px"
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: "16px 24px",
          borderTop: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "flex-end"
        }}>
          <button
            onClick={saveProduct}
            style={{
              padding: "10px 22px",
              background: "#059669",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "600",
              cursor: "pointer"
            }}
          >
            Save Product
          </button>
        </div>

      </div>
    </div>
  );
}

export default OwnerAddProduct;
